import { ResourceOptions } from 'react-admin';
import { MdSwapHoriz } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayHotWalletBalancer;
export {
  XBIT_RELAY_REBALANCES_PERMISSION_RESOURCE,
  XBIT_RELAY_REBALANCES_APPROVE_ACTION,
  XBIT_RELAY_REBALANCES_REJECT_ACTION,
  XBIT_RELAY_REBALANCES_RESOLVE_ACTION,
} from './constants';
export const icon = MdSwapHoriz;
export const options: ResourceOptions = {
  label: 'module.xbitRelayHotWalletBalancer.title',
};
